var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"srch step_s mx-2 mt-3",attrs:{"hide-details":"","single-line":"","height":"36","data-lpignore":"true","outlined":"","placeholder":"Search","append-icon":"mdi-magnify"},model:{value:(_vm.localSearchString),callback:function ($$v) {_vm.localSearchString=$$v},expression:"localSearchString"}})
}
var staticRenderFns = []

export { render, staticRenderFns }